import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content pos-page-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "pos-content d-flex flex-wrap justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_PosLeftContent = _resolveComponent("PosLeftContent")!
  const _component_PosRightContent = _resolveComponent("PosRightContent")!
  const _component_EditContent = _resolveComponent("EditContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PosLeftContent),
        _createVNode(_component_PosRightContent)
      ]),
      _createVNode(_component_EditContent),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\" data-v-29dc78a6><div class=\"offcanvas-body p-0\" data-v-29dc78a6><div class=\"delete-success\" data-v-29dc78a6><img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-29dc78a6><span class=\"text-white fw-medium\" data-v-29dc78a6> Your product is deleted from the list. </span></div></div></div>", 1))
  ], 64))
}